<template>
  <div class="onboarding-home ba-flex ba-f-column ba-gp-1">
    <!--  Stepper Card  -->
    <div v-if="!_isEmpty(show_stepper) && show_stepper" class="ba-card step-by-step ba-flex ba-ai-center ba-jc-sb">
      <svg class="cursor-pointer" xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none" @click="changeStep('',false, true, current)">
        <path d="M11.31 3.68848C10.8753 3.68848 10.44 3.8574 10.1087 4.18957L0.498258 13.8C-0.166086 14.4644 -0.166086 15.54 0.498258 16.2027L10.1087 25.8131C10.7731 26.4775 11.8487 26.4775 12.5113 25.8131L12.6574 25.6671C13.3217 25.0028 13.3217 23.9271 12.6574 23.2645L6.0933 16.7004H28.3009C29.2388 16.7004 30 15.9392 30 15.0013C30 14.0635 29.2388 13.3023 28.3009 13.3023H6.0933L12.6574 6.73821C13.3217 6.07386 13.3217 4.99823 12.6574 4.33559L12.5113 4.18957C12.1792 3.8574 11.7448 3.68848 11.31 3.68848Z" fill="#0072E1"/>
      </svg>

      <onboarding-stepper :view="translation" :callback="changeStep" :current="current"/>

      <div class="ba-flex ba-f-column ba-ai-center ba-gp-04">
        <button class="ba-btn ba-lg ba-blue stepper-button"
                @click="changeStep('', true, false, current)"
        >Next</button>
        <a class="stepper-skip ba-color-blue19 ba-montserrat-700">Skip</a>
      </div>
    </div>

    <!--  Content Card  -->
    <div class="ba-card content-card">
      <div class="ba-flex ba-f-column ba-gp-1 content-left">
        <span class="ba-color-dark5 ba-montserrat-700">{{ translation[view.title] }}</span>
        <span class="ba-color-dark5 ba-montserrat-500">{{ translation[view.subtitle] }}</span>
        <span class="ba-color-black21 ba-montserrat-500">{{ translation[view.description] }}</span>
      </div>
      <img src="/internacional/public/office6/img/onboarding/person-one.svg" class="person">
    </div>

    <!--  Card of Cards  -->
    <div class="ba-card card-of-cards">
      <span class="ba-color-black6 ba-montserrat-700 card--header">{{ translation[view.items_title] }}</span>
      <div class="ba-w-100 ba-flex ba-gp-2 ba-mg-t-2 overflow-auto">
        <div class='ba-card ba-300'
             v-for="(card, i) in view.items"
       x      :key="i"
        >
          <img src='/internacional/public/office6/img/onboarding/example-img.svg' class='ba-image'>
          <span class='ba-title'>{{ card.title }}</span>
          <span class='ba-description'>{{ card.description }}</span>
          <button class='ba-btn ba-md ba-blue text-capitalize'>
            {{ card.text_button }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "onboarding-home",
  props: ["view", "show_stepper", "stepper_callback", "current", "translation"],
  data() {
    return {

    }
  },
  methods: {
    _isEmpty(val) {
      return isEmpty(val)
    },
    changeStep(val, next = false, back = false, current) {
      this.stepper_callback(val, next, back, current)
    }
  }
}
</script>

<style scoped lang="scss">
.onboarding-home {
  width: 1113px;
  height: auto;
  padding: 15px;
  margin: 0 auto;
  .step-by-step {
    width: 100%;
    height: 108px;
    padding: 0 40px;
    flex-direction: row !important;
    align-items: center !important;
    .stepper-button {
      width: 160px;
      text-transform: capitalize !important;
    }
    .stepper-skip {
      font-size: 11.8px;
    }
  }
  .content-card {
    padding: 86px 0 0 45px;

    display: grid;
    grid-template-columns: 475px auto;
    justify-content: space-between;
    .content-left > span {
      &:nth-child(1) {
        font-size: 24px;
      }
      &:nth-child(2) {
        font-size: 14px;
      }
      &:nth-child(3) {
        font-size: 12px;
      }
    }
    .person {
      width: 100%;
      border-radius: 0 0 16px 0;
    }
  }
  .card-of-cards {
    padding: 26px 16px;
    .card--header {
      width: 100%;
      font-size: 12px;
      position: relative;
      &::before {
        position: absolute;
        content: '';
        margin-top: 25px;
        width: 100%;
        background-color: #B4C4D7;
        height: 1.2px;
      }
    }
  }
}
.text-capitalize {
  text-transform: capitalize !important;
}
.ba-300 {
  min-width: 300px;
}
.overflow-auto {
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/onboarding/home.vue